import { cn } from "@/lib/utils/cn";
import { useNavigate } from "react-router-dom";
import type { Post } from "@/types/posts";
import { MediaBlock } from "./post-card/MediaBlock";
import { PostHeader } from "./post-card/PostHeader";
import { PostActionsHelp } from "./post-card/PostActionsHelp";
import { PostActionsDefault } from "./post-card/PostActionsDefault";
import { PostOptionsHandler } from "./post-card/PostOptionsHandler";

interface MobilePostCardProps {
  post: Post;
  onComment: (id: string) => void;
  onShare: (id: string) => void;
  onLocalDelete?: (id: string) => void;
  className?: string;
}

function MobilePostCardHelp({
  post,
  onComment,
  onShare,
  onLocalDelete,
}: MobilePostCardProps) {
  const navigate = useNavigate();

  const handleCommentClick = () => {
    onComment(post.id);
  };

  const handleShareClick = () => {
    onShare(post.id);
  };

  const handleCardClick = () => {
    navigate(`/posts/${post.id}`);
  };

  return (
    <PostOptionsHandler post={post} onLocalDelete={onLocalDelete}>
      {({ handleOptionsClick, optionsSheet }) => (
        <div
          className={cn(
            "glass-primary hover-lift rounded-md mb-4 overflow-hidden relative cursor-pointer",
          )}
          onClick={handleCardClick}
        >
          <PostHeader post={post} onOptionsClick={handleOptionsClick} />
          <div className="px-4 pb-4">
            <p className="text-sm text-midnight-blue whitespace-pre-wrap">
              {post.content}
            </p>
          </div>
          <MediaBlock media={post.media} />
          <PostActionsHelp
            onComment={handleCommentClick}
            onShare={handleShareClick}
          />
          {optionsSheet}
        </div>
      )}
    </PostOptionsHandler>
  );
}

function MobilePostCardDefault({
  post,
  onComment,
  onShare,
  onLocalDelete,
}: MobilePostCardProps) {
  const navigate = useNavigate();

  const handleLikeClick = async () => {
    // TODO: Implement like functionality
  };

  const handleCommentClick = () => {
    onComment(post.id);
  };

  const handleShareClick = () => {
    onShare(post.id);
  };

  const handleCardClick = () => {
    navigate(`/posts/${post.id}`);
  };

  return (
    <PostOptionsHandler post={post} onLocalDelete={onLocalDelete}>
      {({ handleOptionsClick, optionsSheet }) => (
        <div
          className={cn(
            "glass-primary hover-lift rounded-md mb-4 overflow-hidden relative cursor-pointer",
          )}
          onClick={handleCardClick}
        >
          <PostHeader post={post} onOptionsClick={handleOptionsClick} />
          <div className="px-4 pb-4">
            <p className="text-sm text-midnight-blue whitespace-pre-wrap">
              {post.content}
            </p>
          </div>
          <MediaBlock media={post.media} />
          <PostActionsDefault
            isLiked={post.is_liked}
            reactionsCount={post.reactions_count || 0}
            onLike={handleLikeClick}
            onComment={handleCommentClick}
            onShare={handleShareClick}
          />
          {optionsSheet}
        </div>
      )}
    </PostOptionsHandler>
  );
}

export function MobilePostCard(props: MobilePostCardProps) {
  if (props.post.category === "help") {
    return <MobilePostCardHelp {...props} />;
  }
  return <MobilePostCardDefault {...props} />;
}
